import { Component, OnInit } from '@angular/core';
import { MyActiveCall } from '@wephone-core/model/entity/my_active_call';
import { PhoneService } from '@wephone-app-phone/services/phone/phone.service';
import { IPhoneCall } from '@wephone-app-phone/services';
import { DialogComponentBase } from '@wephone-core-ui';
import { MatDialogRef } from '@angular/material/dialog';
import { IFlexDialogConfig, MessageService } from '@wephone-utils';

@Component({
  selector: 'my-active-calls',
  templateUrl: 'my-active-calls.html',
  styleUrls: ['./my-active-calls.scss']
})
export class MyActiveCallsComponent extends DialogComponentBase implements OnInit {
  static wephoneDialogAttrs: IFlexDialogConfig = { contentClass: 'main-content' };

  session_info: any = {};
  active_calls: MyActiveCall[];

  constructor(
    private phoneService: PhoneService,
    private messageService: MessageService,
    dialogRef: MatDialogRef<MyActiveCallsComponent>
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.addSubscription(
      this.messageService.subscribe('phone:call_terminate', (call: IPhoneCall) => {
        this.phoneService.clearActiveCall();
        this.dismiss();
      })
    );
  }

  get activeCall(): IPhoneCall {
    return this.phoneService.getActiveCall();
  }

  get standbyCall(): IPhoneCall {
    return this.phoneService.getStandbyCall();
  }

  hasUnansweredCall(): boolean {
    const activeCall = this.phoneService.getActiveCall();

    return activeCall && !activeCall.isAnswered();
  }

  closeDialog(): void {
    this.dismiss({
      minimize: true
    });
  }
}
